<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<mat-nav-list appAccordion>
    <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems.getMenuitem()"
                   [class.parent-list]="menuitem.children?.length > 0" [disableRipple]="menuitem.children?.length > 0"
                   routerLinkActive="selected"
        group="{{menuitem.state}}" (click)="scrollToTop()">
        <a class="" style="width: 200px;" [routerLink]="['/', menuitem.state]" *ngIf="menuitem.type === 'link'">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name | translate }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <a class="" appAccordionToggle href="{{menuitem.state}}" *ngIf="menuitem.type === 'extLink'">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>
        <a class="" appAccordionToggle href="{{menuitem.state}}" target="_blank" *ngIf="menuitem.type === 'extTabLink'">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name}}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        </a>

        <a class="" (click)="onIconWithText(menuitem.name)" appAccordionToggle href="javascript: void(0);" *ngIf="menuitem.type === 'sub'">
            <mat-icon>{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name | translate }}</span>
            <span fxFlex></span>
            <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
            <!-- <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon> -->
            <mat-icon class="dd-icon" >keyboard_arrow_down</mat-icon>
        </a>
        <mat-nav-list class="sub-item" *ngIf="menuitem.type === 'sub'">
            <mat-list-item appAccordionLink *ngFor="let childitem of menuitem.children; let j=index; let i = childitem"
                routerLinkActive="selected">
                <a [routerLink]="['/', menuitem.state, childitem.state]" *ngIf="childitem.type === 'link'"
                    class="relative" routerLinkActive="selected" (click)="itemSelect[i]=j">
                  <mat-icon>{{ childitem.icon }}</mat-icon>
                  <span>{{ childitem.name | translate }}</span>
                </a>
            </mat-list-item>
            <mat-list-item *ngFor="let childitem of menuitem.children; let j=index; let i=childitem">
                <a class="" href="javascript: void(0);" *ngIf="childitem.type === 'subchild'" (click)="itemSelect[i]=j"
                    [ngClass]="j==itemSelect[i]? 'selected' : ''">
                    <span>{{ childitem.name }}</span>
                    <span fxFlex></span>
                    <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
                </a>
                <mat-nav-list class="child-sub-item" *ngIf="childitem.type === 'subchild'">
                    <mat-list-item *ngFor="let child of childitem.child" routerLinkActive="selected">
                        <a (click)="openDropdownList()" routerLinkActive="selected">{{ child.name }}</a>
                    </mat-list-item>
                </mat-nav-list>
            </mat-list-item>

        </mat-nav-list>

        <div class="saperator text-muted" *ngIf="menuitem.type === 'saperator'">
            <span>{{ menuitem.name }}</span>
        </div>
    </mat-list-item>

    <mat-list-item style="margin-top: 25px;" appAccordionLink>
        <a (click)="logOut()" class="" appAccordionToggle>
            <mat-icon>power_settings_new</mat-icon>
            <span>{{ 'SideBar.LogOut' | translate}}</span>
            <span fxFlex></span>
            <!-- <span class="label label-power_settings_new" >ds</span> -->
        </a>
    </mat-list-item>
</mat-nav-list>